module.exports = __webpack_public_path__ + "static/media/Source Han Sans-01.a37a53f7.svg";